import { ConfirmOptions, useConfirm } from '@/modules/shared/context/ConfirmContext';

/**
 * Hook that returns a wrapper function for confirmable actions.
 */
export function useWrapConfirm() {
  const confirm = useConfirm();

  return function wrapConfirm<T extends (...args: any[]) => any>(
    action: T,
    options?: ConfirmOptions,
  ) {
    return async (...args: Parameters<T>) => {
      const ok = await confirm({
        ...options,
        title: options?.title ?? '',
        message: options?.message ?? 'Are you sure?',
      });
      if (ok) action(...args);
    };
  };
}
